import draggable from 'vuedraggable'
export default {
    name: 'DetailsTab',
    props: {
        recallData: {
            type: Object,
            default: null
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        validationErrors: {
            type: Array,
            default: () => []
        },
        viewOnlyRecallFeed: {
            type: Boolean,
            default: false
        }
    },
    components: {
        PdfViewer: require('@/components/core/PdfViewer.vue').default,
        CustomDatePicker: require('@/components/noti/DatePicker').default,
        draggable
    },
    data() {
        return {
            selectedDocument: null,
            selectedPdfDoc: null,
            pdfLoading: false,
            pdfAutoSelected: false,
            pdfError: null,
            pdfZoom: 100,
            pdfRotation: 0,
            pdfPage: 1,
            pdfNumPages: 0,
            editingField: null,
            editValue: '',
            tempData: {},
            originalRecallingFirmAddress: null,
            tempFieldValues: {
                recall_name: '',
                recall_id: '',
                recall_date: null,
                urgent: false,
                recalling_firm: '',
                recalling_firm_address: {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                },
                manufacturer: '',
                response_email: '',
                additional_contact_info: '',
                recall_type: '',
                fda_classification: '',
                description: '',
                health_risk: '',
                instructions: '',
                recall_category: '',
                isVoluntary: ''
            },
            emailValidationError: false,
            recallTypeOptions: [
                { value: 'Correction', text: 'Correction' },
                { value: 'Removal', text: 'Removal' },
                { value: 'Field Safety Notice', text: 'Field Safety Notice' }
            ],
            fdaClassificationOptions: [
                { value: 'Class I', text: 'Class I' },
                { value: 'Class II', text: 'Class II' },
                { value: 'Class III', text: 'Class III' },
                { value: 'Not Yet Classified', text: 'Not Yet Classified' }
            ],
            recallCategoryOptions: [
                { value: 'Medical Devices', text: 'Medical Devices' },
                { value: 'Drugs', text: 'Drugs' },
                { value: 'Biologics', text: 'Biologics' },
                { value: 'Food', text: 'Food' }
            ],
            isVoluntaryOptions: [
                { value: 'Supplier Voluntary', text: 'Supplier Voluntary' },
                { value: 'Regulatory Mandate', text: 'Regulatory Mandate' }
            ],
            recallMetaData: null,
            editingProduct: null, // Format: { index, field }
            editingProductIndex: null, // Track which product is being edited as a whole
            tempProductValues: {
                name: '',
                udi: '',
                lot_number: '',
                serial_number: '',
                catalog_number: '',
                model_number: '',
                part_number: '',
                version: '',
                distribution_time_period: '',
                expiration_time_period: '',
                manufactured_time_period: '',
                device_size: '',
                material_description: '',
                item_number: '',
                sku: '',
                ship_date: null,
                product_number: ''
            },
            isAddingNewProduct: false,
            editingActionId: null,
            tempActionValue: '',
            isAddingNewAction: false,
            newActionValue: '',
            editingInstructionId: null,
            tempInstructionValue: '',
            isAddingNewInstruction: false,
            newInstructionValue: '',
            editingInstructionIndex: null, // For card-based editing
            tempInstructionCardValue: '',  // For card-based editing
            editingActionIndex: null, // For action card-based editing
            tempActionCardValue: '',  // For action card-based editing
            activeToasts: new Set(), // Track active toast messages
            isDragging: false,
            delayedDragging: false,
            editingResponseField: null, // Format: { fieldId, index }
            tempResponseFieldValue: '',
            tempResponseFieldLabel: '',
            actionsColumnDefs: [
                {
                    headerName: 'Action',
                    field: 'action',
                    flex: 1,
                    sortable: false,
                    filter: false,
                    resizable: false,
                    wrapText: true,
                    autoHeight: true,
                    editable: false,
                    suppressMenu: true,
                    suppressRowDrag: true,
                    cellRenderer: (params) => {
                        if (params.data.isEditing) {
                            return `
                                <input 
                                    type="text" 
                                    class="form-control form-control-sm action-edit-input" 
                                    value="${params.value}" 
                                    data-index="${params.data.index}"
                                    draggable="false"
                                    ondragstart="event.preventDefault(); event.stopPropagation(); return false;"
                                    ondrag="event.preventDefault(); event.stopPropagation(); return false;"
                                    ondragend="event.preventDefault(); event.stopPropagation(); return false;"
                                    onmousedown="event.stopPropagation();"
                                    style="width: 100%; height: 100%; border: 1px solid #ced4da; padding: 4px 8px; -webkit-user-drag: none; user-select: text;"
                                />
                            `
                        }
                        return `<div style="padding: 4px 8px;">${params.value}</div>`
                    }
                },
                {
                    headerName: '',
                    field: 'actions',
                    width: 120,
                    sortable: false,
                    filter: false,
                    resizable: false,
                    pinned: 'right',
                    editable: false,
                    suppressMenu: true,
                    cellRenderer: (params) => {
                        if (params.data.isEditing) {
                            return `
                                <div style="display: flex; gap: 8px; align-items: center; justify-content: center; height: 100%;">
                                    <i class="fas fa-save" style="cursor: pointer; color: #007bff;" data-action="save" data-index="${params.data.index}"></i>
                                    <i class="fas fa-times" style="cursor: pointer; color: #6c757d;" data-action="cancel" data-index="${params.data.index}"></i>
                                </div>
                            `
                        }
                        return `
                            <div style="display: flex; gap: 8px; align-items: center; justify-content: center; height: 100%;">
                                <i class="fas fa-edit" style="cursor: pointer; color: #007bff;" data-action="edit" data-index="${params.data.index}"></i>
                                <i class="fas fa-trash" style="cursor: pointer; color: #dc3545;" data-action="delete" data-index="${params.data.index}"></i>
                            </div>
                        `
                    }
                }
            ],
            actionsGridOptions: {
                suppressHorizontalScroll: true,
                suppressRowClickSelection: true,
                suppressMovableColumns: true,
                suppressColumnVirtualisation: true,
                singleClickEdit: true,
                stopEditingWhenCellsLoseFocus: true,
                suppressRowDrag: true,
                rowDragManaged: false,
                domLayout: 'autoHeight',
                defaultColDef: {
                    sortable: false,
                    filter: false,
                    resizable: false,
                    wrapText: true,
                    autoHeight: true,
                    suppressMenu: true
                }
            },
            instructionsColumnDefs: [
                {
                    headerName: 'Instruction',
                    field: 'instruction',
                    flex: 1,
                    sortable: false,
                    filter: false,
                    resizable: false,
                    wrapText: true,
                    autoHeight: true,
                    editable: false,
                    suppressMenu: true,
                    suppressRowDrag: true,
                    cellRenderer: (params) => {
                        if (params.data.isEditing) {
                            return `
                                <input 
                                    type="text" 
                                    class="form-control form-control-sm instruction-edit-input" 
                                    value="${params.value}" 
                                    data-index="${params.data.index}"
                                    draggable="false"
                                    ondragstart="event.preventDefault(); event.stopPropagation(); return false;"
                                    ondrag="event.preventDefault(); event.stopPropagation(); return false;"
                                    ondragend="event.preventDefault(); event.stopPropagation(); return false;"
                                    onmousedown="event.stopPropagation();"
                                    style="width: 100%; height: 100%; border: 1px solid #ced4da; padding: 4px 8px; -webkit-user-drag: none; user-select: text;"
                                />
                            `
                        }
                        return `<div style="padding: 4px 8px;">${params.value}</div>`
                    }
                },
                {
                    headerName: '',
                    field: 'actions',
                    width: 120,
                    sortable: false,
                    filter: false,
                    resizable: false,
                    pinned: 'right',
                    editable: false,
                    suppressMenu: true,
                    cellRenderer: (params) => {
                        if (params.data.isEditing) {
                            return `
                                <div style="display: flex; gap: 8px; align-items: center; justify-content: center; height: 100%;">
                                    <i class="fas fa-save" style="cursor: pointer; color: #007bff;" data-action="save" data-index="${params.data.index}"></i>
                                    <i class="fas fa-times" style="cursor: pointer; color: #6c757d;" data-action="cancel" data-index="${params.data.index}"></i>
                                </div>
                            `
                        }
                        return `
                            <div style="display: flex; gap: 8px; align-items: center; justify-content: center; height: 100%;">
                                <i class="fas fa-edit" style="cursor: pointer; color: #007bff;" data-action="edit" data-index="${params.data.index}"></i>
                                <i class="fas fa-trash" style="cursor: pointer; color: #dc3545;" data-action="delete" data-index="${params.data.index}"></i>
                            </div>
                        `
                    }
                }
            ],
            instructionsGridOptions: {
                suppressHorizontalScroll: true,
                suppressRowClickSelection: true,
                suppressMovableColumns: true,
                suppressColumnVirtualisation: true,
                singleClickEdit: true,
                stopEditingWhenCellsLoseFocus: true,
                suppressRowDrag: true,
                rowDragManaged: false,
                domLayout: 'autoHeight',
                defaultColDef: {
                    sortable: false,
                    filter: false,
                    resizable: false,
                    wrapText: true,
                    autoHeight: true,
                    suppressMenu: true
                }
            }
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 150,
                group: 'actions',
                ghostClass: 'ghost',
                disabled: this.isEditingDisabled
            }
        },
        documentOptions() {
            if (!this.recallData?.documents || this.recallData.documents.length === 0) {
                return []
            }
            return this.recallData.documents.map((doc, index) => ({
                id: index,
                label: doc.filename || doc.input_file || `Document ${index + 1}`,
                url: doc.url,
                size: doc.size || 0,
                icon: '<i class="fas fa-file-pdf text-danger"></i>'
            }))
        },
        isEditing() {
            return !!(this.editingField ||
                     this.editingProductIndex !== null ||
                     this.editingProduct ||
                     this.isAddingNewProduct ||
                     this.editingActionId !== null ||
                     this.isAddingNewAction ||
                     this.editingInstructionId !== null ||
                     this.isAddingNewInstruction ||
                     this.editingResponseField !== null)
        },
        isMandatoryFieldsValid() {
            if (!this.recallData?.recall_info) return false
            const info = this.recallData.recall_info
            return true
        },
        hasValidationError() {
            return (fieldName) => {
                return this.validationErrors && this.validationErrors.includes(fieldName)
            }
        },
        // Check if editing should be disabled
        isEditingDisabled() {
            if (!this.recallData) return true

            const disabledStates = ['Duplicate', 'Pending Verification']
            return (
                disabledStates.includes(this.recallData.originality) ||
                this.recallData.status === 'PUBLISHED'
            )
        },
        actionsTableData() {
            if (!this.recallData?.recall_info?.actions) return []
            return this.recallData.recall_info.actions.map((action, index) => {
                const actionId = action.id || index
                return {
                    id: actionId,
                    action: action.value || action,
                    index: index,
                    isEditing: this.editingActionId === actionId
                }
            })
        },
        instructionsTableData() {
            if (!this.recallData?.recall_info?.instructions) return []
            return this.recallData.recall_info.instructions.map((instruction, index) => {
                const instructionId = instruction.id || index
                return {
                    id: instructionId,
                    instruction: instruction.value || instruction,
                    index: index,
                    isEditing: this.editingInstructionId === instructionId
                }
            })
        }
    },
    watch: {
        isEditing(newValue) {
            this.$emit('editing-state-changed', newValue)
        },
        isMandatoryFieldsValid(newValue) {
            this.$emit('validation-state-changed', newValue)
        },
        recallData: {
            handler(newValue, oldValue) {
                // Reset states when navigating to a different record
                if (newValue && oldValue && newValue.id !== oldValue.id) {
                    this.resetAllEditingStates()
                    this.pdfAutoSelected = false
                    this.selectedDocument = null
                    this.selectedPdfDoc = null
                    this.pdfError = null
                    this.pdfZoom = 100
                    this.pdfRotation = 0
                    this.pdfPage = 1
                    this.pdfNumPages = 0
                }
            },
            immediate: true,
            deep: false
        }
    },
    methods: {
        onMove({ relatedContext, draggedContext }) {
            const relatedElement = relatedContext.element
            const draggedElement = draggedContext.element
            return (
                (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
            )
        },

        onActionDragEnd() {
            this.isDragging = false;

            // Re-assign sequence_number based on new order (same pattern as component.js)
            const reorderedActions = this.recallData.recall_info.actions.map((action, index) => ({
                ...action,
                order: index + 1
            }))

            // Update local data with new sequence numbers
            this.recallData.recall_info.actions = reorderedActions
            // Only emit if actions have actually been reordered
            this.$emit('action-reorder', this.recallData.recall_info.actions)
        },

        onInstructionDragEnd() {
            this.isDragging = false;
            // Re-assign sequence_number based on new order
            const reorderedInstructions = this.recallData.recall_info.instructions.map((instruction, index) => ({
                ...instruction,
                order: index + 1
            }))

            // Update local data with new sequence numbers
            this.recallData.recall_info.instructions = reorderedInstructions
            // Only emit if instructions have actually been reordered
            this.$emit('instruction-reorder', this.recallData.recall_info.instructions)
        },

        // PDF Viewer Methods
        selectPdf(doc) {
            this.selectedPdfDoc = doc
            this.pdfAutoSelected = true
            this.pdfError = null
            this.pdfZoom = 100
            this.pdfRotation = 0
            this.pdfPage = 1
            this.pdfNumPages = 0

            // Show loading spinner for large files >10MB
            if (doc.size && doc.size > 10 * 1024 * 1024) {
                this.pdfLoading = true
            } else {
                this.pdfLoading = false
            }
        },

        handleDocumentSelection(documentId) {
            window.open(documentId, '_blank')
        },

        onPdfLoaded() {
            this.pdfLoading = false
            this.pdfError = null
        },

        onPdfError(error) {
            this.pdfLoading = false
            this.pdfError = 'Error: Document cannot be previewed. Please check file integrity or download to view locally.'
            console.error('PDF loading error:', error)
        },

        zoomIn() {
            if (this.pdfZoom < 200) {
                this.pdfZoom += 25
            }
        },

        zoomOut() {
            if (this.pdfZoom > 50) {
                this.pdfZoom -= 25
            }
        },

        resetZoom() {
            this.pdfZoom = 100
        },

        rotateLeft() {
            this.pdfRotation = (this.pdfRotation - 90 + 360) % 360
        },

        rotateRight() {
            this.pdfRotation = (this.pdfRotation + 90) % 360
        },

        nextPage() {
            if (this.pdfPage < this.pdfNumPages) {
                this.pdfPage++
            }
        },

        prevPage() {
            if (this.pdfPage > 1) {
                this.pdfPage--
            }
        },

        onNumPages(numPages) {
            this.pdfNumPages = numPages
        },

        downloadDocument() {
            if (this.selectedPdfDoc && this.selectedPdfDoc.url) {
                window.open(this.selectedPdfDoc.url, '_blank')
            }
        },

        formatFileSize(bytes) {
            if (!bytes || bytes === 0) return 'Unknown size'
            const units = ['B', 'KB', 'MB', 'GB']
            let size = bytes
            let unitIndex = 0
            while (size >= 1024 && unitIndex < units.length - 1) {
                size /= 1024
                unitIndex++
            }
            return `${size.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`
        },

        /**
         * Extracts the calendar date (YYYY-MM-DD) from various date formats.
         * This is the core function that ensures timezone-independent date handling.
         * @param {Date|string|object} dateValue - The date value (Date object, ISO string, or MongoDB $date object)
         * @returns {object|null} - { year, month, day } or null
         */
        extractDateComponents(dateValue) {
            if (!dateValue) return null

            // Handle MongoDB $date format: { "$date": "2022-10-18T00:00:00.000Z" }
            const value = dateValue?.$date || dateValue

            if (!value) return null

            // If it's a string, extract YYYY-MM-DD directly (no timezone conversion)
            if (typeof value === 'string') {
                const match = value.match(/(\d{4})-(\d{2})-(\d{2})/)
                if (match) {
                    return {
                        year: parseInt(match[1], 10),
                        month: parseInt(match[2], 10),
                        day: parseInt(match[3], 10)
                    }
                }
            }

            // If it's a Date object, extract LOCAL date components
            // (Date picker returns Date at local midnight)
            if (value instanceof Date && !isNaN(value.getTime())) {
                return {
                    year: value.getFullYear(),
                    month: value.getMonth() + 1,
                    day: value.getDate()
                }
            }

            return null
        },

        /**
         * Converts a date to API format (YYYY-MM-DDTHH:mm:ss.SSSZ).
         * Extracts the calendar date and formats as UTC midnight.
         */
        formatDateForAPI(date) {
            const components = this.extractDateComponents(date)
            if (!components) return null

            const { year, month, day } = components
            const monthStr = String(month).padStart(2, '0')
            const dayStr = String(day).padStart(2, '0')

            return `${year}-${monthStr}-${dayStr}T00:00:00.000Z`
        },

        /**
         * Formats a date for display (MM/DD/YYYY).
         * Extracts the calendar date directly without timezone conversion.
         */
        formatDateForDisplay(date) {
            const components = this.extractDateComponents(date)
            if (!components) return '-'

            const { year, month, day } = components
            const monthStr = String(month).padStart(2, '0')
            const dayStr = String(day).padStart(2, '0')

            return `${monthStr}/${dayStr}/${year}`
        },

        /**
         * Converts an API date to a Date object suitable for the date picker.
         * Creates Date at LOCAL NOON (12:00) to avoid timezone boundary issues.
         * Using noon gives a 12-hour buffer in either direction for timezone shifts.
         */
        convertDateForPicker(dateValue) {
            const components = this.extractDateComponents(dateValue)
            if (!components) return null

            const { year, month, day } = components
            // Create date at NOON LOCAL time to avoid midnight timezone edge cases
            return new Date(year, month - 1, day, 12, 0, 0)
        },

        // Parse date string to Date object at UTC midnight (legacy - kept for compatibility)
        parseAsUTCDate(dateString) {
            if (!dateString) return null
            try {
                // Handle MongoDB $date format
                const value = dateString?.$date || dateString
                const dateMatch = String(value).match(/(\d{4})-(\d{2})-(\d{2})/)
                if (dateMatch) {
                    const year = parseInt(dateMatch[1], 10)
                    const month = parseInt(dateMatch[2], 10) - 1 // Month is 0-indexed
                    const day = parseInt(dateMatch[3], 10)
                    return new Date(Date.UTC(year, month, day))
                }
                return null
            } catch (error) {
                return null
            }
        },

        getStatusClass(status) {
            const statusMap = {
                'PUBLISHED': 'badge-success',
                'PENDING': 'badge-warning',
            }
            return statusMap[status] || 'badge-secondary'
        },

        showToast(message, options = {}) {
            // Create a unique key for this toast message
            const toastKey = `${message}_${options.variant || 'default'}`
            // Check if this toast is already showing
            if (this.activeToasts.has(toastKey)) {
                return
            }
            // Add to active toasts
            this.activeToasts.add(toastKey)
            // Show the toast
            this.$bvToast.toast(message, {
                title: options.title || 'Notification',
                variant: options.variant || 'info',
                solid: true,
                toaster: 'b-toaster-top-center',
                autoHideDelay: options.autoHideDelay || 3000,
                ...options
            })
            // Remove from active toasts after it's hidden
            setTimeout(() => {
                this.activeToasts.delete(toastKey)
            }, (options.autoHideDelay || 3000) + 500)
        },

        openDocument(url) {
            if (url) {
                window.open(url, '_blank')
            }
        },
        fetchActionsData(params) {
            // For simple display-only grid with clientSide data
            const dataSource = {
                getRows: (rowParams) => {
                    const data = this.actionsTableData
                    rowParams.successCallback(data, data.length)
                }
            }
            params.api.setServerSideDatasource(dataSource)
        },
        onActionCellClicked(params) {
            const action = params.event.target.dataset.action
            const rowIndex = parseInt(params.event.target.dataset.index)
            // Get the actual data from the row
            const rowData = this.actionsTableData.find((item, idx) => item.index === rowIndex)
            if (!rowData) return

            if (action === 'edit') {
                this.startEditAction(rowData.id, rowData.index)
            } else if (action === 'save') {
                // Get the current value from the input field before saving
                const input = document.querySelector('.action-edit-input')
                if (input) {
                    this.tempActionValue = input.value
                }
                this.saveEditAction(rowData.id, rowData.index)
            } else if (action === 'cancel') {
                this.cancelEditAction()
            } else if (action === 'delete') {
                this.deleteAction(rowData.index)
            }
        },
        startEditAction(actionId, index) {
            this.editingActionId = actionId
            const action = this.recallData.recall_info.actions[index]
            // Handle both object format {id, value} and string format
            if (typeof action === 'object' && action.value) {
                this.tempActionValue = action.value
            } else {
                this.tempActionValue = action
            }
            // Refresh grid to show input textbox
            this.$nextTick(() => {
                if (this.$refs.actionsGrid && this.$refs.actionsGrid.gridApi) {
                    this.$refs.actionsGrid.gridApi.refreshServerSide({ purge: true })
                    // Focus the input after rendering
                    this.$nextTick(() => {
                        const input = document.querySelector('.action-edit-input')
                        if (input) {
                            input.focus()
                            input.select()
                            // Add event listeners
                            input.addEventListener('keyup', (e) => {
                                if (e.key === 'Enter') {
                                    this.saveEditActionFromInput(actionId, index, e.target.value)
                                } else if (e.key === 'Escape') {
                                    this.cancelEditAction()
                                }
                            })
                            input.addEventListener('input', (e) => {
                                this.tempActionValue = e.target.value
                            })
                            input.addEventListener('dragstart', (e) => {
                                e.preventDefault()
                                e.stopPropagation()
                            })
                            input.addEventListener('drag', (e) => {
                                e.preventDefault()
                                e.stopPropagation()
                            })
                        }
                    })
                }
            })
        },
        saveEditAction(actionId, index) {
            if (!this.tempActionValue || !this.tempActionValue.trim()) {
                this.showToast('Action cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }
            const currentAction = this.recallData.recall_info.actions[index]
            let updatedAction
            if (typeof currentAction === 'object' && currentAction.id) {
                updatedAction = {
                    id: currentAction.id,
                    value: this.tempActionValue
                }
            } else {
                updatedAction = {
                    value: this.tempActionValue
                }
            }
            this.$emit('action-update', { id: actionId, index, action: updatedAction })
            // Wait for parent to update data first, then clear editing state and refresh grid
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.editingActionId = null
                    this.tempActionValue = ''
                    this.$nextTick(() => {
                        this.refreshActionsGrid()
                    })
                })
            })
        },
        saveEditActionFromInput(actionId, index, value) {
            this.tempActionValue = value
            this.saveEditAction(actionId, index)
        },
        cancelEditAction() {
            this.editingActionId = null
            this.tempActionValue = ''
            this.refreshActionsGrid()
        },
        deleteAction(index) {
            this.$bvModal.msgBoxConfirm(
                'Are you sure you want to delete this action? This action cannot be undone.',
                {
                    title: 'Confirm Delete',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Delete',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.$emit('action-delete', index)
                        this.$nextTick(() => {
                            this.refreshActionsGrid()
                        })
                    }
                })
                .catch(() => {
                    // Error showing confirmation dialog
                })
        },
        addNewAction() {
            this.isAddingNewAction = true
            this.newActionValue = ''
        },
        saveNewAction() {
            if (!this.newActionValue.trim()) {
                this.showToast('Action cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }
            const actions = this.recallData?.recall_info?.actions || []
            const hasOrderField = actions.length > 0 && actions.some(action => action.order !== undefined)
            const newAction = { value: this.newActionValue }
            if (hasOrderField) {
                const maxOrder = Math.max(...actions.map(action => action.order || 0))
                newAction.order = maxOrder + 1
            }
            this.$emit('action-add', newAction)
            this.cancelNewAction()
            this.refreshActionsGrid()
        },
        cancelNewAction() {
            this.isAddingNewAction = false
            this.newActionValue = ''
        },
        refreshActionsGrid() {
            this.$nextTick(() => {
                if (this.$refs.actionsGrid && this.$refs.actionsGrid.gridApi) {
                    this.$refs.actionsGrid.gridApi.refreshServerSide({ purge: true })
                    this.$forceUpdate()
                }
            })
        },

        // Instructions methods
        fetchInstructionsData(params) {
            const dataSource = {
                getRows: (rowParams) => {
                    const data = this.instructionsTableData
                    rowParams.successCallback(data, data.length)
                }
            }
            params.api.setServerSideDatasource(dataSource)
        },
        onInstructionCellClicked(params) {
            const action = params.event.target.dataset.action
            const rowIndex = parseInt(params.event.target.dataset.index)
            const rowData = this.instructionsTableData.find((item, idx) => item.index === rowIndex)
            if (!rowData) return

            if (action === 'edit') {
                this.startEditInstruction(rowData.id, rowData.index)
            } else if (action === 'save') {
                const input = document.querySelector('.instruction-edit-input')
                if (input) {
                    this.tempInstructionValue = input.value
                }
                this.saveEditInstruction(rowData.id, rowData.index)
            } else if (action === 'cancel') {
                this.cancelEditInstruction()
            } else if (action === 'delete') {
                this.deleteInstruction(rowData.index)
            }
        },
        startEditInstruction(instructionId, index) {
            this.editingInstructionId = instructionId
            const instruction = this.recallData.recall_info.instructions[index]
            if (typeof instruction === 'object' && instruction.value) {
                this.tempInstructionValue = instruction.value
            } else {
                this.tempInstructionValue = instruction
            }
            this.$nextTick(() => {
                if (this.$refs.instructionsGrid && this.$refs.instructionsGrid.gridApi) {
                    this.$refs.instructionsGrid.gridApi.refreshServerSide({ purge: true })
                    this.$nextTick(() => {
                        const input = document.querySelector('.instruction-edit-input')
                        if (input) {
                            input.focus()
                            input.select()
                            input.addEventListener('keyup', (e) => {
                                if (e.key === 'Enter') {
                                    this.saveEditInstructionFromInput(instructionId, index, e.target.value)
                                } else if (e.key === 'Escape') {
                                    this.cancelEditInstruction()
                                }
                            })
                            input.addEventListener('input', (e) => {
                                this.tempInstructionValue = e.target.value
                            })
                            input.addEventListener('dragstart', (e) => {
                                e.preventDefault()
                                e.stopPropagation()
                            })
                            input.addEventListener('drag', (e) => {
                                e.preventDefault()
                                e.stopPropagation()
                            })
                        }
                    })
                }
            })
        },
        saveEditInstruction(instructionId, index) {
            if (!this.tempInstructionValue || !this.tempInstructionValue.trim()) {
                this.showToast('Instruction cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }
            const currentInstruction = this.recallData.recall_info.instructions[index]
            let updatedInstruction
            if (typeof currentInstruction === 'object' && currentInstruction.id) {
                updatedInstruction = {
                    id: currentInstruction.id,
                    value: this.tempInstructionValue
                }
            } else {
                updatedInstruction = {
                    value: this.tempInstructionValue
                }
            }
            this.$emit('instruction-update', { id: instructionId, index, instruction: updatedInstruction })
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.editingInstructionId = null
                    this.tempInstructionValue = ''
                    this.$nextTick(() => {
                        this.refreshInstructionsGrid()
                    })
                })
            })
        },
        saveEditInstructionFromInput(instructionId, index, value) {
            this.tempInstructionValue = value
            this.saveEditInstruction(instructionId, index)
        },
        cancelEditInstruction() {
            this.editingInstructionId = null
            this.tempInstructionValue = ''
            this.refreshInstructionsGrid()
        },
        deleteInstruction(index) {
            this.$bvModal.msgBoxConfirm(
                'Are you sure you want to delete this instruction? This action cannot be undone.',
                {
                    title: 'Confirm Delete',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Delete',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.$emit('instruction-delete', index)
                        this.$nextTick(() => {
                            this.refreshInstructionsGrid()
                        })
                    }
                })
                .catch(() => {
                    // Error showing confirmation dialog
                })
        },
        addNewInstruction() {
            this.isAddingNewInstruction = true
            this.newInstructionValue = ''
        },
        saveNewInstruction() {
            if (!this.newInstructionValue.trim()) {
                this.showToast('Instruction cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }
            const instructions = this.recallData?.recall_info?.actions || []
            const hasInstructionField = instructions.length > 0 && instructions.some(instruction => instruction.order !== undefined)
            const newInstruction = { value: this.newInstructionValue }
            if (hasInstructionField) {
                const maxOrder = Math.max(...instructions.map(instruction => instruction.order || 0))
                newInstruction.order = maxOrder + 1
            }
            // const newInstruction = { value: this.newInstructionValue }
            this.$emit('instruction-add', newInstruction)
            this.cancelNewInstruction()
            this.refreshInstructionsGrid()
        },
        cancelNewInstruction() {
            this.isAddingNewInstruction = false
            this.newInstructionValue = ''
        },
        refreshInstructionsGrid() {
            this.$nextTick(() => {
                if (this.$refs.instructionsGrid && this.$refs.instructionsGrid.gridApi) {
                    this.$refs.instructionsGrid.gridApi.refreshServerSide({ purge: true })
                    this.$forceUpdate()
                }
            })
        },

        getInstructionsText(instructions) {
            if (!instructions || instructions.length === 0) return ''
            // Convert array of instructions to newline-separated text
            return instructions.map(item => item.value || item).join('\n')
        },

        startEdit(field, currentValue) {
            this.editingField = field
            this.emailValidationError = false
            if (field === 'recall_date') {
                // For date field, convert for picker display
                this.tempFieldValues[field] = this.convertDateForPicker(currentValue)
            } else if (field === 'isVoluntary') {
                // For isVoluntary field, default to 'Supplier Voluntary' if not set
                this.tempFieldValues[field] = currentValue || 'Supplier Voluntary'
            } else if (field === 'recalling_firm_address') {
                // Store the original address for comparison
                this.originalRecallingFirmAddress = currentValue ? {
                    street: currentValue.street || '',
                    town: currentValue.town || '',
                    state: currentValue.state || '',
                    zipcode: currentValue.zipcode || '',
                    country: currentValue.country || ''
                } : {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                }
                // For recalling_firm_address, handle object with nested properties
                this.tempFieldValues[field] = currentValue ? {
                    street: currentValue.street || '',
                    town: currentValue.town || '',
                    state: currentValue.state || '',
                    zipcode: currentValue.zipcode || '',
                    country: currentValue.country || ''
                } : {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                }
            }
            else if (field === 'urgent') {
                // For isVoluntary field, default to 'Supplier Voluntary' if not set
                this.tempFieldValues[field] = currentValue || false
            } else {
                this.tempFieldValues[field] = currentValue || ''
            }
        },

        cancelEdit() {
            this.editingField = null
            this.emailValidationError = false
            // Clear all temp values
            this.tempFieldValues = {
                recall_name: '',
                recall_id: '',
                recall_date: null,
                urgent: false,
                recalling_firm: '',
                recalling_firm_address: {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                },
                manufacturer: '',
                response_email: '',
                additional_contact_info: '',
                recall_type: '',
                fda_classification: '',
                description: '',
                health_risk: '',
                instructions: '',
                recall_category: ''
            }
        },

        saveEdit(field) {
            // Validate email if the field is response_email
            if (field === 'response_email' && this.tempFieldValues[field]) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                if (!emailRegex.test(this.tempFieldValues[field])) {
                    this.emailValidationError = true
                    this.showToast('Please enter a valid email address', {
                        title: 'Invalid Email',
                        variant: 'danger'
                    })
                    return
                }
            }

            this.emailValidationError = false
            // Handle recalling_firm_address separately to detect individual field changes
            if (field === 'recalling_firm_address') {
                const oldAddress = this.originalRecallingFirmAddress || {}
                const newAddress = this.tempFieldValues[field]
                // Check each address field for changes and emit individually
                const addressFields = ['street', 'town', 'state', 'zipcode', 'country']
                let hasChanges = false
                addressFields.forEach(addressField => {
                    const oldValue = oldAddress[addressField] || ''
                    const newValue = newAddress[addressField] || ''
                    if (oldValue !== newValue) {
                        hasChanges = true
                        this.$emit('field-update', {
                            field: `recalling_firm_address.${addressField}`,
                            value: newValue,
                            oldValue: oldValue
                        })
                    }
                })
                if (!hasChanges) {
                    this.showToast('No changes detected', {
                        title: 'Info',
                        variant: 'info',
                        autoHideDelay: 2000
                    })
                }
                // Clear the stored original address
                this.originalRecallingFirmAddress = null
            } else {
                // Check if value has actually changed before emitting update
                const currentValue = this.recallData?.recall_info?.[field]
                let hasChanged = false

                if (field === 'recall_date') {
                    // Compare dates by converting both to API format strings
                    const oldDateStr = currentValue ? this.formatDateForAPI(currentValue) : null
                    const newDateStr = this.tempFieldValues[field] ? this.formatDateForAPI(this.tempFieldValues[field]) : null
                    hasChanged = oldDateStr !== newDateStr
                } else {
                    // For non-date fields, simple comparison
                    hasChanged = currentValue !== this.tempFieldValues[field]
                }

                if (hasChanged) {
                    // For date fields, convert to API format before emitting
                    let valueToEmit = this.tempFieldValues[field]
                    let oldValueToEmit = currentValue

                    if (field === 'recall_date') {
                        valueToEmit = this.formatDateForAPI(this.tempFieldValues[field])
                        oldValueToEmit = currentValue ? this.formatDateForAPI(currentValue) : null
                    }

                    // Emit the save event with field name and new value
                    this.$emit('field-update', {
                        field: field,
                        value: valueToEmit,
                        oldValue: oldValueToEmit
                    })
                }
            }
            this.editingField = null
            // Clear the temp value after saving
            if (field === 'recall_date') {
                this.tempFieldValues[field] = null
            } else if (field === 'urgent') {
                this.tempFieldValues[field] = false
            } else if (field === 'recalling_firm_address') {
                this.tempFieldValues[field] = {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                }
            } else {
                this.tempFieldValues[field] = ''
            }
        },

        startEditProduct(productIndex, field, currentValue) {
            this.editingProduct = { index: productIndex, field: field }
            const dateFields = [
                'distribution_start_date',
                'distribution_end_date',
                'expiration_start_date',
                'expiration_end_date',
                'manufactured_start_date',
                'manufactured_end_date',
                'ship_date'
            ]
            if (dateFields.includes(field)) {
                this.tempProductValues[field] = this.convertDateForPicker(currentValue)
            } else {
                this.tempProductValues[field] = currentValue || ''
            }
        },

        startEditWholeProduct(productIndex, product) {
            // Cancel add new product mode if active
            if (this.isAddingNewProduct) {
                this.isAddingNewProduct = false
            }
            this.editingProductIndex = productIndex
            // Load all product values into temp
            // Use class method to convert dates for picker
            this.tempProductValues = {
                name: product.name || '',
                udi: product.udi || '',
                lot_number: product.lot_number || '',
                serial_number: product.serial_number || '',
                catalog_number: product.catalog_number || '',
                model_number: product.model_number || '',
                part_number: product.part_number || '',
                version: product.version || '',
                distribution_start_date: this.convertDateForPicker(product.distribution_start_date),
                distribution_end_date: this.convertDateForPicker(product.distribution_end_date),
                expiration_start_date: this.convertDateForPicker(product.expiration_start_date),
                expiration_end_date: this.convertDateForPicker(product.expiration_end_date),
                manufactured_start_date: this.convertDateForPicker(product.manufactured_start_date),
                manufactured_end_date: this.convertDateForPicker(product.manufactured_end_date),
                device_size: product.device_size || '',
                material_description: product.material_description || '',
                item_number: product.item_number || '',
                sku: product.sku || '',
                ship_date: this.convertDateForPicker(product.ship_date),
                product_number: product.product_number || ''
            }
        },

        cancelEditProduct() {
            this.editingProduct = null
            this.editingProductIndex = null
            // Clear all temp product values
            this.tempProductValues = {
                name: '',
                udi: '',
                lot_number: '',
                serial_number: '',
                catalog_number: '',
                model_number: '',
                part_number: '',
                version: '',
                distribution_start_date: null,
                distribution_end_date: null,
                expiration_start_date: null,
                expiration_end_date: null,
                manufactured_start_date: null,
                manufactured_end_date: null,
                device_size: '',
                material_description: '',
                item_number: '',
                sku: '',
                ship_date: null,
                product_number: ''
            }
        },

        saveWholeProduct(productIndex) {
            // Validate product name is required
            if (!this.tempProductValues.name || this.tempProductValues.name.trim() === '') {
                this.showToast('Product name is required', {
                    title: 'Validation Error',
                    variant: 'danger'
                })
                return
            }

            // Validate Distribution dates
            if (this.tempProductValues.distribution_start_date && this.tempProductValues.distribution_end_date) {
                const startDate = this.convertDateForPicker(this.tempProductValues.distribution_start_date)
                const endDate = this.convertDateForPicker(this.tempProductValues.distribution_end_date)
                if (endDate < startDate) {
                    this.showToast('Distribution End Date must be greater than or equal to Distribution Start Date', {
                        title: 'Validation Error',
                        variant: 'danger'
                    })
                    return
                }
            }

            // Validate Expiration dates
            if (this.tempProductValues.expiration_start_date && this.tempProductValues.expiration_end_date) {
                const startDate = this.convertDateForPicker(this.tempProductValues.expiration_start_date)
                const endDate = this.convertDateForPicker(this.tempProductValues.expiration_end_date)
                if (endDate < startDate) {
                    this.showToast('Expiration End Date must be greater than or equal to Expiration Start Date', {
                        title: 'Validation Error',
                        variant: 'danger'
                    })
                    return
                }
            }

            // Validate Manufactured dates
            if (this.tempProductValues.manufactured_start_date && this.tempProductValues.manufactured_end_date) {
                const startDate = this.convertDateForPicker(this.tempProductValues.manufactured_start_date)
                const endDate = this.convertDateForPicker(this.tempProductValues.manufactured_end_date)
                if (endDate < startDate) {
                    this.showToast('Manufactured End Date must be greater than or equal to Manufactured Start Date', {
                        title: 'Validation Error',
                        variant: 'danger'
                    })
                    return
                }
            }

            // Process date fields - dates may be raw strings from API or Date objects from date picker
            const productData = { ...this.tempProductValues }
            const dateFields = [
                'distribution_start_date',
                'distribution_end_date',
                'expiration_start_date',
                'expiration_end_date',
                'manufactured_start_date',
                'manufactured_end_date',
                'ship_date'
            ]
            // Get current product for comparison
            const currentProduct = this.recallData.recall_info.product_list[productIndex]
            // First pass: normalize dates and check for changes
            const changedFields = []
            dateFields.forEach(field => {
                const value = productData[field]
                if (value) {
                    // If it's a Date object from date picker, convert to API format
                    // If it's already a string from API, formatDateForAPI will handle it
                    const newDateStr = this.formatDateForAPI(value)
                    const oldDateStr = currentProduct[field] || null
                    // Check if date actually changed by comparing normalized values
                    const oldNormalized = oldDateStr ? this.formatDateForAPI(oldDateStr) : null
                    if (oldNormalized !== newDateStr) {
                        // Date changed - use the new value
                        productData[field] = newDateStr
                        changedFields.push(field)
                    } else {
                        // Date unchanged - use the original value
                        productData[field] = oldDateStr
                    }
                } else {
                    productData[field] = null
                }
            })

            // Check if any field has actually changed
            let hasChanges = false
            const allFields = Object.keys(productData)

            for (const field of allFields) {
                const currentValue = currentProduct[field]
                const newValue = productData[field]

                if (dateFields.includes(field)) {
                    // Already checked in the loop above
                    if (changedFields.includes(field)) {
                        hasChanges = true
                        break
                    }
                } else {
                    // For non-date fields, normalize empty values
                    const oldVal = currentValue || ''
                    const newVal = newValue || ''
                    if (oldVal !== newVal) {
                        hasChanges = true
                        break
                    }
                }
            }

            if (!hasChanges) {
                this.editingProductIndex = null
                return
            }

            // Emit event to update entire product
            this.$emit('product-update-all', {
                index: productIndex,
                product: productData
            })
            this.editingProductIndex = null
            this.showToast('Product updated successfully', {
                title: 'Success',
                variant: 'success',
                solid: true,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 3000
            })
            // Clear temp values
            this.tempProductValues = {
                name: '',
                udi: '',
                lot_number: '',
                serial_number: '',
                catalog_number: '',
                model_number: '',
                part_number: '',
                version: '',
                distribution_start_date: null,
                distribution_end_date: null,
                expiration_start_date: null,
                expiration_end_date: null,
                manufactured_start_date: null,
                manufactured_end_date: null,
                device_size: '',
                material_description: '',
                item_number: '',
                sku: '',
                ship_date: null,
                product_number: ''
            }
        },

        saveEditProduct(productIndex, field) {
            // Get current product data to check related dates
            const currentProduct = this.recallData.recall_info.product_list[productIndex]

            // Validate Distribution dates
            if (field === 'distribution_start_date' || field === 'distribution_end_date') {
                const startDate = field === 'distribution_start_date'
                    ? this.convertDateForPicker(this.tempProductValues[field])
                    : this.convertDateForPicker(currentProduct.distribution_start_date)
                const endDate = field === 'distribution_end_date'
                    ? this.convertDateForPicker(this.tempProductValues[field])
                    : this.convertDateForPicker(currentProduct.distribution_end_date)

                if (startDate && endDate && endDate < startDate) {
                    this.showToast('Distribution End Date must be greater than or equal to Distribution Start Date', {
                        title: 'Validation Error',
                        variant: 'danger'
                    })
                    return
                }
            }

            // Validate Expiration dates
            if (field === 'expiration_start_date' || field === 'expiration_end_date') {
                const startDate = field === 'expiration_start_date'
                    ? this.convertDateForPicker(this.tempProductValues[field])
                    : this.convertDateForPicker(currentProduct.expiration_start_date)
                const endDate = field === 'expiration_end_date'
                    ? this.convertDateForPicker(this.tempProductValues[field])
                    : this.convertDateForPicker(currentProduct.expiration_end_date)

                if (startDate && endDate && endDate < startDate) {
                    this.showToast('Expiration End Date must be greater than or equal to Expiration Start Date', {
                        title: 'Validation Error',
                        variant: 'danger',
                        autoHideDelay: 3000
                    })
                    return
                }
            }

            // Validate Manufactured dates
            if (field === 'manufactured_start_date' || field === 'manufactured_end_date') {
                const startDate = field === 'manufactured_start_date'
                    ? this.convertDateForPicker(this.tempProductValues[field])
                    : this.convertDateForPicker(currentProduct.manufactured_start_date)
                const endDate = field === 'manufactured_end_date'
                    ? this.convertDateForPicker(this.tempProductValues[field])
                    : this.convertDateForPicker(currentProduct.manufactured_end_date)

                if (startDate && endDate && endDate < startDate) {
                    this.showToast('Manufactured End Date must be greater than or equal to Manufactured Start Date', {
                        title: 'Validation Error',
                        variant: 'danger',
                        autoHideDelay: 3000
                    })
                    return
                }
            }

            // Convert date value to UTC if it's a date field
            const dateFields = [
                'distribution_start_date',
                'distribution_end_date',
                'expiration_start_date',
                'expiration_end_date',
                'manufactured_start_date',
                'manufactured_end_date',
                'ship_date'
            ]
            let valueToSave = this.tempProductValues[field]
            if (dateFields.includes(field) && valueToSave) {
                valueToSave = this.formatDateForAPI(valueToSave)
            }

            // Check if value has actually changed before emitting update
            const currentValue = currentProduct[field]
            let hasChanged = false

            if (dateFields.includes(field)) {
                // Compare dates by converting both to API format strings
                const oldDateStr = currentValue ? this.formatDateForAPI(currentValue) : null
                const newDateStr = valueToSave
                hasChanged = oldDateStr !== newDateStr
            } else {
                // For non-date fields, simple comparison
                hasChanged = currentValue !== valueToSave
            }

            if (hasChanged) {
                // Emit the save event with product index, field name and new value
                this.$emit('product-update', {
                    index: productIndex,
                    field: field,
                    value: valueToSave
                })
            }
            this.editingProduct = null
            // Clear the temp value after saving
            if (field === 'ship_date') {
                this.tempProductValues[field] = null
            } else {
                this.tempProductValues[field] = ''
            }
        },

        deleteProduct(productIndex) {
            this.$bvModal.msgBoxConfirm(
                'Are you sure you want to delete this product? This action cannot be undone.',
                {
                    title: 'Confirm Delete',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Delete',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.$emit('product-delete', productIndex)
                        this.showToast('Product deleted successfully', {
                            title: 'Success',
                            variant: 'success',
                            autoHideDelay: 3000
                        })
                    }
                })
                .catch(() => {
                    // Error showing confirmation dialog
                })
        },

        // Card-based instruction methods
        startEditInstructionCard(index, instruction) {
            this.editingInstructionIndex = index
            this.tempInstructionCardValue = instruction.value || ''
        },

        saveInstructionCard(index) {
            if (!this.tempInstructionCardValue.trim()) {
                this.showToast('Instruction cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }

            const updatedInstruction = {
                ...this.recallData.recall_info.instructions[index],
                value: this.tempInstructionCardValue
            }

            this.$emit('instruction-update', { index, instruction: updatedInstruction })

            this.editingInstructionIndex = null
            this.tempInstructionCardValue = ''
            this.refreshInstructionsGrid()
        },

        cancelEditInstructionCard() {
            this.editingInstructionIndex = null
            this.tempInstructionCardValue = ''
        },

        deleteInstructionCard(index) {
            this.$bvModal.msgBoxConfirm(
                'Are you sure you want to delete this instruction? This action cannot be undone.',
                {
                    title: 'Confirm Delete',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Delete',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.$emit('instruction-delete', index)
                        this.refreshInstructionsGrid()
                    }
                })
                .catch(() => {
                    // Error showing confirmation dialog
                })
        },

        // Action card methods for responsive table
        startEditActionCard(index, action) {
            this.editingActionIndex = index
            this.tempActionCardValue = action.value || ''
        },

        saveActionCard(index) {
            if (!this.tempActionCardValue.trim()) {
                this.showToast('Action cannot be empty', {
                    title: 'Warning',
                    variant: 'warning'
                })
                return
            }

            const updatedAction = {
                ...this.recallData.recall_info.actions[index],
                value: this.tempActionCardValue
            }

            this.$emit('action-update', { index, action: updatedAction })

            this.editingActionIndex = null
            this.tempActionCardValue = ''
            this.refreshActionsGrid()
        },

        cancelEditActionCard() {
            this.editingActionIndex = null
            this.tempActionCardValue = ''
        },

        deleteActionCard(index) {
            this.$bvModal.msgBoxConfirm(
                'Are you sure you want to delete this action? This action cannot be undone.',
                {
                    title: 'Confirm Delete',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Delete',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            )
                .then(value => {
                    if (value) {
                        this.$emit('action-delete', index)
                        this.refreshActionsGrid()
                    }
                })
                .catch(() => {
                    // Error showing confirmation dialog
                })
        },

        addNewProduct() {
            // Cancel any ongoing product edit first
            if (this.editingProductIndex !== null) {
                this.editingProductIndex = null
            }
            this.isAddingNewProduct = true
            // Reset temp values for new product
            this.tempProductValues = {
                name: '',
                udi: '',
                lot_number: '',
                serial_number: '',
                catalog_number: '',
                model_number: '',
                part_number: '',
                version: '',
                distribution_start_date: null,
                distribution_end_date: null,
                expiration_start_date: null,
                expiration_end_date: null,
                manufactured_start_date: null,
                manufactured_end_date: null,
                device_size: '',
                material_description: '',
                item_number: '',
                sku: '',
                ship_date: null,
                product_number: ''
            }
        },

        cancelNewProduct() {
            this.isAddingNewProduct = false
            // Clear temp values
            this.tempProductValues = {
                name: '',
                udi: '',
                lot_number: '',
                serial_number: '',
                catalog_number: '',
                model_number: '',
                part_number: '',
                version: '',
                distribution_start_date: null,
                distribution_end_date: null,
                expiration_start_date: null,
                expiration_end_date: null,
                manufactured_start_date: null,
                manufactured_end_date: null,
                device_size: '',
                material_description: '',
                item_number: '',
                sku: '',
                ship_date: null,
                product_number: ''
            }
        },

        saveNewProduct() {
            // Validate at least name is provided
            if (!this.tempProductValues.name || this.tempProductValues.name.trim() === '') {
                this.showToast('Product name is required', {
                    title: 'Validation Error',
                    variant: 'danger',
                    autoHideDelay: 3000
                })
                return
            }

            // Validate Distribution dates
            if (this.tempProductValues.distribution_start_date && this.tempProductValues.distribution_end_date) {
                const startDate = this.convertDateForPicker(this.tempProductValues.distribution_start_date)
                const endDate = this.convertDateForPicker(this.tempProductValues.distribution_end_date)
                if (endDate < startDate) {
                    this.showToast('Distribution End Date must be greater than or equal to Distribution Start Date', {
                        title: 'Validation Error',
                        variant: 'danger',
                        autoHideDelay: 3000
                    })
                    return
                }
            }

            // Validate Expiration dates
            if (this.tempProductValues.expiration_start_date && this.tempProductValues.expiration_end_date) {
                const startDate = this.convertDateForPicker(this.tempProductValues.expiration_start_date)
                const endDate = this.convertDateForPicker(this.tempProductValues.expiration_end_date)
                if (endDate < startDate) {
                    this.showToast('Expiration End Date must be greater than or equal to Expiration Start Date', {
                        title: 'Validation Error',
                        variant: 'danger',
                        autoHideDelay: 3000
                    })
                    return
                }
            }

            // Validate Manufactured dates
            if (this.tempProductValues.manufactured_start_date && this.tempProductValues.manufactured_end_date) {
                const startDate = this.convertDateForPicker(this.tempProductValues.manufactured_start_date)
                const endDate = this.convertDateForPicker(this.tempProductValues.manufactured_end_date)
                if (endDate < startDate) {
                    this.showToast('Manufactured End Date must be greater than or equal to Manufactured Start Date', {
                        title: 'Validation Error',
                        variant: 'danger',
                        autoHideDelay: 3000
                    })
                    return
                }
            }

            // Convert all date fields to UTC before emitting
            const productData = { ...this.tempProductValues }
            const dateFields = [
                'distribution_start_date',
                'distribution_end_date',
                'expiration_start_date',
                'expiration_end_date',
                'manufactured_start_date',
                'manufactured_end_date',
                'ship_date'
            ]
            dateFields.forEach(field => {
                if (productData[field]) {
                    productData[field] = this.formatDateForAPI(productData[field])
                }
            })

            // Emit event to add new product
            this.$emit('product-add', productData)
            this.isAddingNewProduct = false
            this.showToast('Product added successfully', {
                title: 'Success',
                variant: 'success',
                autoHideDelay: 3000
            })
            // Clear temp values
            this.tempProductValues = {
                name: '',
                udi: '',
                lot_number: '',
                serial_number: '',
                catalog_number: '',
                model_number: '',
                part_number: '',
                version: '',
                distribution_start_date: null,
                distribution_end_date: null,
                expiration_start_date: null,
                expiration_end_date: null,
                manufactured_start_date: null,
                manufactured_end_date: null,
                device_size: '',
                material_description: '',
                item_number: '',
                sku: '',
                ship_date: null,
                product_number: ''
            }
        },

        resetAllEditingStates() {
            // Reset field editing
            this.editingField = null
            this.emailValidationError = false
            this.tempFieldValues = {
                recall_name: '',
                recall_id: '',
                recall_date: null,
                urgent: false,
                recalling_firm: '',
                recalling_firm_address: {
                    street: '',
                    town: '',
                    state: '',
                    zipcode: '',
                    country: ''
                },
                manufacturer: '',
                response_email: '',
                additional_contact_info: '',
                recall_type: '',
                fda_classification: '',
                description: '',
                health_risk: '',
                instructions: '',
                recall_category: '',
                isVoluntary: ''
            }

            // Reset product editing
            this.editingProduct = null
            this.editingProductIndex = null
            this.isAddingNewProduct = false
            this.tempProductValues = {
                name: '',
                udi: '',
                lot_number: '',
                serial_number: '',
                catalog_number: '',
                model_number: '',
                part_number: '',
                version: '',
                distribution_start_date: null,
                distribution_end_date: null,
                expiration_start_date: null,
                expiration_end_date: null,
                manufactured_start_date: null,
                manufactured_end_date: null,
                device_size: '',
                material_description: '',
                item_number: '',
                sku: '',
                ship_date: null,
                product_number: ''
            }

            // Reset action editing
            this.editingActionId = null
            this.tempActionValue = ''
            this.isAddingNewAction = false
            this.newActionValue = ''

            // Reset instruction editing
            this.editingInstructionId = null
            this.tempInstructionValue = ''
            this.isAddingNewInstruction = false
            this.newInstructionValue = ''

            // Reset response field editing
            this.editingResponseField = null
            this.tempResponseFieldLabel = ''
            this.tempResponseFieldValue = ''
        },

        // Response Form Methods
        updateResponseField(fieldId, index, value) {
            // Emit update event to parent for text/signature fields
            this.$emit('response-form-update', {
                fieldId,
                index,
                value: value
            })
        },

        updateResponseDateField(fieldId, index, dateValue) {
            // Convert date to API format and emit update
            const formattedDate = dateValue ? this.formatDateForAPI(dateValue) : null
            this.$emit('response-form-update', {
                fieldId,
                index,
                value: formattedDate
            })
        },

        updateResponseCheckbox(fieldId, index, checked) {
            // Emit update event to parent for checkbox
            this.$emit('response-form-update', {
                fieldId,
                index,
                value: checked
            })
        },

        startEditResponseField(fieldId, index) {
            const responseField = this.recallData.recall_info.response_form[index]
            this.editingResponseField = { fieldId, index }
            this.tempResponseFieldLabel = responseField.key || ''


            // Set initial value based on field type
            if (responseField.type === 'CHECKBOX') {
                this.tempResponseFieldValue = responseField.value || false
            } else if (responseField.type === 'DATE') {
                this.tempResponseFieldValue = responseField.value ? this.convertDateForPicker(responseField.value) : null
            } else if (responseField.type === 'RADIO') {
                this.tempResponseFieldValue = responseField.value || ''
            } else {
                this.tempResponseFieldValue = responseField.value || ''
            }
        },

        getRadioOptions(options) {
            // Convert options object to array format for b-form-radio-group
            if (!options || typeof options !== 'object') {
                return []
            }
            return Object.keys(options).map(key => ({
                text: options[key],
                value: key
            }))
        },

        saveEditResponseField(fieldId, index) {
            const responseField = this.recallData.recall_info.response_form[index]

            // Validate label
            if (!this.tempResponseFieldLabel || !this.tempResponseFieldLabel.trim()) {
                this.showToast('Label cannot be empty', {
                    title: 'Validation Error',
                    variant: 'danger',
                    autoHideDelay: 3000
                })
                return
            }

            // Emit updates
            const updates = []

            // Update label if changed
            if (this.tempResponseFieldLabel !== responseField.label) {
                updates.push({
                    fieldId,
                    field: 'key',
                    value: this.tempResponseFieldLabel.trim()
                })
            }

            // Update value if changed
            let valueChanged = false
            let formattedValue = this.tempResponseFieldValue

            if (responseField.type === 'date' && this.tempResponseFieldValue) {
                formattedValue = this.formatDateForAPI(this.tempResponseFieldValue)
                valueChanged = formattedValue !== responseField.value
            } else if (responseField.type === 'checkbox') {
                valueChanged = this.tempResponseFieldValue !== responseField.value
            } else {
                valueChanged = this.tempResponseFieldValue !== responseField.value
            }

            if (valueChanged) {
                updates.push({
                    fieldId,
                    field: 'value',
                    value: formattedValue
                })
            }

            // Emit all updates
            if (updates.length > 0) {
                this.$emit('response-field-update-multiple', updates, index)
            }

            // Clear editing state
            this.cancelEditResponseField()
        },

        cancelEditResponseField() {
            this.editingResponseField = null
            this.tempResponseFieldLabel = ''
            this.tempResponseFieldValue = ''
        }
    }
}